import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Folder, FolderCreate } from '@lockton-apps/shared/interfaces';
import { Observable, of } from 'rxjs';
import { getDevConfig } from '@lockton-apps/shared/util/helpers';
import { MocksService } from '@lockton-apps/shared/util/mocks';

@Injectable({
  providedIn: 'root',
})
export class FoldersService {
  modelPlural = 'document/folders';
  modelSingular = 'document/folder';

  constructor(
    @Optional() private readonly mocksService: MocksService,
    @Inject('BASE_API_URL') private baseUrl: string,
    private http: HttpClient
  ) {}

  private _getUrlPlural() {
    return `${this.baseUrl}/${this.modelPlural}`;
  }

  private _getUrlSingular() {
    return `${this.baseUrl}/${this.modelSingular}`;
  }

  private _getUrlForClientId(id: number) {
    return `${this._getUrlPlural()}/${id}`;
  }

  allForClient(clientId: number) {
    if (getDevConfig('client.fullMock')) {
      return of(this.mocksService.getClientFolders(clientId));
    }

    return this.http.get<Folder[]>(this._getUrlForClientId(clientId));
  }

  add(folder: FolderCreate) {
    return this.http.post<Folder>(this._getUrlSingular(), folder);
  }

  update(folder: Partial<Folder>): Observable<Folder> {
    return this.http.patch<Folder>(this._getUrlSingular(), folder);
  }

  delete(id: number): Observable<Folder> {
    return this.http.delete<Folder>(`${this._getUrlSingular()}/${id}`);
  }
}
